import React, {Component} from 'react';
import { injectIntl } from "react-intl";
import PlanningCalendar from "./PlanningCalendar";
import {connect} from "react-redux";
import { getCamelCaseType } from "../WheelsExchangeUtils";
import moment from 'moment';
import Constants from "../../../services/Constants";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import {withRouter} from "react-router-dom";
import SwitchPlanningSlots from "./SwitchPlanningSlots";

class SwitchPlanning extends Component {

  constructor(props) {
    super(props);
    this.state = {
      planning: {},
      selectedDay: (props.day) ? props.day : moment().format(Constants.DATE_FORMAT_API) // by default select today
    }
  }

  componentDidMount() {
    const {onChangeDate} = this.props;
    const {type, dispatchFetchWheelsExchangePlanning, dispatchFetchSwitchExchangeSlots} = this.props;
    const {selectedDay} = this.state;
    dispatchFetchWheelsExchangePlanning({type, day: selectedDay});
    dispatchFetchSwitchExchangeSlots({type, day: selectedDay});
    onChangeDate(selectedDay);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.fetchWheelsExchangePlanning && nextProps.fetchWheelsExchangePlanning.planning) {
      this.setState({planning: nextProps.fetchWheelsExchangePlanning.planning});
    }
  }

  onSelectedDateChange = day => {
    const {dispatchFetchSwitchExchangeSlots, type, onChangeDate} = this.props;
    dispatchFetchSwitchExchangeSlots({type, day});
    this.setState({selectedDay: day});
    onChangeDate(day);
  };

  render() {
    const {fetchWheelsExchangePlanning: {loading}, type, index, onUpdate} = this.props;
    const {planning, selectedDay} = this.state;
    return (
      <div className="box__body">
        <div className="row">
          <div className="col-md-7 col-xxl-7">
            {loading ?
              <LoadingIndicator/>
              :
              <PlanningCalendar planning={planning} selectedDay={selectedDay} onSelect={this.onSelectedDateChange}/>
            }
          </div>
          <div className="col-md-5 col-xxl-5">
            <SwitchPlanningSlots type={type} day={selectedDay} index={index} onUpdate={onUpdate} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps)=> {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const fetchWheelsExchangePlanning = state[`fetch${camelCaseType}ExchangePlanning`];
  return {
    fetchWheelsExchangePlanning
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchFetchWheelsExchangePlanning: request => dispatch({type: `FETCH_${ownProps.type}_EXCHANGE_PLANNING.REQUEST`, request}),
  dispatchFetchSwitchExchangeSlots: request => dispatch({type: 'FETCH_SWITCH_EXCHANGE_SLOTS.REQUEST', request})
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SwitchPlanning)));



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/management/SwitchPlanning.js